import React from "react"

const Badge = React.forwardRef(({ className = "", variant = "default", children, ...props }, ref) => {
  let badgeClass = "badge"

  switch (variant) {
    case "secondary":
      badgeClass += " badge-secondary"
      break
    case "destructive":
      badgeClass += " badge-destructive"
      break
    case "outline":
      badgeClass += " badge-outline"
      break
    default:
      badgeClass += " badge-secondary"
  }

  if (className) {
    badgeClass += " " + className
  }

  return (
    <div ref={ref} className={badgeClass} {...props}>
      {children}
    </div>
  )
})
Badge.displayName = "Badge"

export { Badge }
